import React from 'react';
import { Typography } from '@mui/material';
import GridContainer from 'components/shared/GridContainer';
import GridItem from 'components/shared/GridItem';
import Card from 'components/shared/Card';
import { IPCheckSession } from 'store/types/Meeting';
import { IPCheckType, QuestionResponse } from 'store/enums/BallotReviewTypes';
import { ipCheckTypeLabel } from 'util/meeting';

interface IPCheckSessionViewCardProps {
  ipCheckSession: IPCheckSession;
}

const IPCheckSessionViewCard: React.FunctionComponent<IPCheckSessionViewCardProps> = ({ ipCheckSession }) => {
  const patentConflictAnswer =
    ipCheckSession.patentConflict === QuestionResponse.Yes
      ? 'Yes, at least one of them is a patented technology'
      : ipCheckSession.patentConflict === QuestionResponse.No
      ? 'No'
      : '';

  return (
    <GridContainer>
      <GridItem>
        <Card bordered>
          <GridContainer spacing={1}>
            <GridItem md={2}>
              <Typography>
                <strong>Result:</strong> {ipCheckTypeLabel[ipCheckSession.type]}
              </Typography>
            </GridItem>
            {ipCheckSession.type === IPCheckType.Affirmative && !ipCheckSession.copyrightSummary && (
              <GridItem md={12}>
                <Typography>
                  <strong>Is any of the known IPs a patented technology?: </strong>
                  {patentConflictAnswer}
                </Typography>
              </GridItem>
            )}
            {ipCheckSession.type === IPCheckType.Affirmative && ipCheckSession.patentSummary && (
              <>
                <GridItem md={12}>
                  <Typography>
                    <strong>Patented Technologies</strong>
                  </Typography>
                </GridItem>
                <GridItem md={12}>
                  <Typography>Total numbers of Patented Technologies to be dealt with</Typography>
                </GridItem>
                <GridItem md={12}>
                  <Typography>
                    <strong>Known Patented Technology that might be relevant to the Standard/Safety Guideline: </strong>
                    {ipCheckSession.patentSummary.totalConflicts}
                  </Typography>
                </GridItem>
                <GridItem md={12}>
                  <Typography>
                    <strong>
                      Number of patented technologies first became known to the TC Chapter on or after the day of the
                      issuance of this Letter Ballot:
                    </strong>{' '}
                    {ipCheckSession.patentSummary.conflictsAfterIssuance}
                  </Typography>
                </GridItem>
                <GridItem md={12}>
                  <Typography>
                    <strong>
                      Number of patented technologies first became known to the TC Chapter before the day of the
                      issuance of this Letter Ballot:
                    </strong>{' '}
                    {ipCheckSession.patentSummary.conflictsBeforeIssuance}
                  </Typography>
                </GridItem>
              </>
            )}
          </GridContainer>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default IPCheckSessionViewCard;
